import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { PageMetaDefault } from '../../constants';

/**
 * Выбирает pageMeta для текущего pathname
 */
export const selectCurrentPageMeta = createSelector(
  (state: IApplicationState) => state.pagesMeta.items,
  (_: IApplicationState, pathname: string) => pathname,
  (pagesMeta, pathname) => {
    const pageMeta = pagesMeta.find(pageMeta => pageMeta.pathname === pathname);

    return pageMeta || PageMetaDefault;
  },
);
